import { Component, OnInit } from '@angular/core';
import * as data from '../../data/servicio.data';


@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styles: [
  ]
})
export class ServicesComponent implements OnInit {

  lista = data.lista;

  constructor() { }

  ngOnInit(): void {
  }

}
